export default {
    error: {
        HousingCompanyNotFound: "Taloyhtiötä ei löydy",
        HousingCompanyNotAvailable: "Palvelu ei ole taloyhtiön käytössä",
        AlreadyRegistered: "Olet jo rekisteröitynyt taloyhtiöön",
    },

    common: {
        search: "Hae",
        loading: "Ladataan...",
        next: "Seuraava",
        firstName: "Etunimi",
        lastName: "Sukunimi",
        email: "Sähköposti",
        pin: "Pin",
        streetAddress: "Katuosoite",
        zipCode: "Postinumero",
        city: "Kaupunki",
        phone: "Puhelinnumero",
        ssn: "Henkilöturvatunnus",
        save: "Tallenna",
        confirm: "Vahvista",
        monday: "Maanantai",
        tuesday: "Tiistai",
        wednesday: "Keskiviikko",
        thursday: "Torstai",
        friday: "Perjantai",
        saturday: "Lauantai",
        sunday: "Sunnuntai",
        free: "Vapaa",
        reserved: "Varattu",
        download: "Lataa",
        noRights: "Tämä toiminto tulee näkyviin kun isännöitsijä on hyväksynyt tietosi taloyhtiössä",
        read: "Lue",
        send: "Lähetä",
        back: "Takaisin",
        apartment: "Huoneisto",
        ok: "Ok",
        yes: "Kyllä",
        no: "Ei",
        companyName: "Yrityksen nimi",
        company: "Yritys",
        businessId: "Y-tunnus",
        youHaveNewMessage: "Sinulle on uusi viesti"
    },

    menu: {
        home: "Etusivu",
        ownInfo: "Omat tiedot",
        housingCompanyInfo: "Yhteystiedot",
        messages: "Tiedotteet",
        materialBank: "Materiaalipankki",
        saunaShifts: "Saunavuorot",
        parkingSpaces: "Autopaikat",
        notes: "Muistutukset",
        emergencyPlan: "Pelastussuunnitelma",
        switchHousingCompany: "Vaihda taloyhtiö",
        logOut: "Kirjaudu ulos",
        arrivalNotice: "Tuloilmoitus",
        defectNotice: "Vikailmoitus",
        leavingNotice: "Lähtöilmoitus",
        materials: "Materiaalit",
        requests: "Viestit",
    },

    chooseView: {
        topic: "Valitse taloyhtiö",
        subtopic: "Valitse taloyhtiö, jonka tietoja haluat tarkastella",
        noCompanies: "Haullasi ei löydy tuloksia",
        search: "Hae taloyhtiöitä",
        searchTopic: "Lisää taloyhtiö",
    },

    notAvailableView: {
        topic: "Kirjaudu",
        subtopic: "Palvelu ei ole käytössä taloyhtiöllä {0}. Ota yhteyttä isännöitsijään, mikäli haluat palvelun käyttöön",
    },

    inputEmailView: {
        topic: "Kirjaudu",
        subtopic: "Syötä sähköpostiosoitteesi",
    },

    inputPinView: {
        topic: "Kirjaudu",
        subtopic: "Lähetimme sinulle PIN-koodin, jonka avulla voit kirjautua sisään. Pin vanhentuu 5 minuutin kuluttua.",
        resendPinPhone: "Lähetä PIN uudelleen puhelimeen",
        resendPinEmail: "Lähetä PIN uudelleen sähköpostiin",
        login: "Kirjaudu",
    },

    inputRegisterView: {
        topic: "Rekisteröidy",
        subtopic: "Täytä oheinen lomake rekisteröityäksesi sovellukseen",
        register: "Rekisteröidy"
    },

    welcomeView: {
        topic: "Tervetuloa",
        messages: "Tiedotteet",
        materials: "Materiaalit",
        allMessages: "Kaikki tiedotteet",
        allMaterials: "Kaikki materiaalit",
        emergencyPlan1: "Pelastus-",
        emergencyPlan2: "suunnitelma",
        doArrivalNotice: "Tee tuloilmoitus",
        doDefectNotice: "Tee vikailmoitus",
    },

    housingCompanyInfoView: {
        topic: "Yhteystiedot",
        installation: "Isännöintitoimisto",
        housingManager: "Isännöitsijä",
        maintenanceCompany: "Huoltoyhtiö",
    },

    saunaShiftsView: {
        topic: "Saunavuorot",
        subtopic: "Valitse päivämäärä ja sauna. Alla olevasta listasta näet saunavuoron tilan. Voit tehdä varaus- tai peruutusilmoituksen saunavuorosta.",
        order: "Varaa vuoro",
        confirmReservation: "Haluatko varmasti varata vuoron saunaan {0} päivälle {1} {2}?",
        confirmRemoveReservation: "Haluatko varmasti poistaa saunavuorosi saunaan {0} päivälle {1} {2}",
        ownShifts: "Omat saunavuorot",
        reserve: "Varaa saunavuoro",
        cancel: "Peru",
        removeReservationInstructions: "Tähän tiedot esim. aikarajasta, jolloin saunavuoron voi vielä perua ennen saunavuoron alkua.",
        removeReservationSuccess: "Saunavuoron peruminen onnistui.",
        reservationSuccess: "Varauspyyntö vastaanotettu.",
        notAvailable: "Tämä vuoro ei ole varattavissa",
        isOwn: "Oma vuoro",
        isQueuedForRemove: "Oma vuoro merkitty poistettavaksi",
        isQueuedForReserve: "Varauspyyntö odottaa käsittelyä",
    },

    parkingView: {
        topic: "Autopaikat",
        subtopic: "Valitse parkkialue ja -paikka. Näet onko kyseinen paikka vapaa/varattu ja voit tehdä varauksen.",
        order: "Varaa paikka",
        confirmReservation: "Haluatko varmasti varata parkkipaikan {0} alueelta {1}?",
        ownSlots: "Omat autopaikat",
        reserve: "Varaa autopaikka",
        reservationSuccess: "Autopaikkavaraus lähetetty onnistuneesti",
        slot: "Paikka",
        removeSlot: "Pura sopimus",
        confirmRemoveReservation: "Haluatko varmasti purkaa sopimuksen alueen {0} parkkipaikasta {1}?",
        removeReservationSuccess: "Autopaikan purkusopimus lähetetty onnistuneesti",
        warming: "Sähkö",
        charging: "Latausmahdollisuus",
        warmSpot: "Lämmin autopaikka",
        instructions: "Luovutus- ja käyttöohjeet",
        conditionsOfContract: "Sopimusehdot",
    },

    emergencyPlanView: {
        topic: "Lataa pelastussuunnitelma",
        noEmergencyPlan: "Ei pelastussuunnitelmaa",
    },

    messagesView: {
        noMessages: "Ei tiedotteita",
        topic: "Tiedotteet",
        subtopic: "Alle on listattu kaikki taloyhtiösi tiedotteet.",
        messages: "Tiedotteet",
    },

    messageView: {
        topic: "Tiedotteet",
        allMessages: "Kaikki tiedotteet",
    },

    materialBankView: {
        noMaterials: "Ei materiaaleja",
        topic: "Materiaalit",
        subtopic: "Alle on listattu taloyhtiösi materiaalit",
        materials: "Materiaalit",
    },

    arrivalNoticeView: {
        topic: "Tuloilmoitus",
        subtopic1: "Täytä lomakkeen tiedot ja allekirjoita sopimus. Isännöitsijä käsittelee tuloilmoituksen, jonka jälkeen saat onnistuneesta ilmoituksesta viestin.",
        subtopic2: "Muistathan tehdä myös muuttoilmoituksen väestörekisteriin ja postiin, sillä tuloilmoituksen tekeminen ei korvaa lakisääteisen muuttoilmoituksen tekoa.",
        subtopic3: "Tuloilmoituksen jättäminen on tärkeää mm. seuraavista syistä",
        subtopic4: "Nimesi voidaan merkitä oveen ja portaassa olevaan nimitauluun",
        subtopic5: "Ovesi voidaan avata sinulle yleisavaimella, jos oma avaimesi on unohtunut kotiin",
        apartmentInfo: "Asunnon tiedot",
        moverInfo: "Muuttajien tiedot",
        otherMoverInfo: "Muiden muuttajien tiedot",
        signature: "Allekirjoitus (tunnistautumistapa)",
        streetAddress: "Katuosoite",
        postCodeAndCity: "Postinumero ja -toimipaikka",
        apartment: "Huoneisto",
        moveInDate: "Muuttopäivä",
        surnamesToDoor: "Oveen tulevat sukunimet",
        phone: "Puhelinnumero päivisin",
        name: "Etunimi Sukunimi",
        addPerson: "Lisää henkilö",
        removePerson: "Poista henkilö",
        noticeSentSuccessfully: "Tiedot tallennettu onnistuneesti. Saat tiedon ja pääset käyttämään palvelun kaikkia toimintoja kun tuloilmoituksesi on käsitelty.",
        arrivalRole: "Rooli",
        arrivalRoleTenant: "Vuokralainen",
        arrivalRoleStakeholder: "Osakas",
        choose: "Valitse",
        previousPartyLeaves: "Edelliset asukkaat poistuvat",
        addToCurrentParty: "Muutan nykyisten asukkaiden lisäksi",
    },

    ownInfoView: {
        topic: "Omat tiedot",
        description: "Alla näet listan taloyhtiöistäsi. Voit muokata listaa, jolloin muutospyyntösi välittyy taloyhtiön isännöitsijälle.",
        apartment: "Huoneisto",
        editInfo: "Muokkaa tietoja",
        changedOwnInfoSuccessfully: "Käyttäjätietojen muutos onnistui",
        removeHousingCompany: "Poista taloyhtiö",
        doArrivalNotice: "Tee tuloilmoitus",
        doLeavingNotice: "Tee lähtöilmoitus",
        doDefectNotice: "Tee vikailmoitus",
        waitingForConfirmation: "Tila: Odottaa isännöitsijän vahvistusta",
        confirmRemove: "Oletko varma että haluat poistaa taloyhtiön?",
        noApartments: "Sinulla ei ole yhtään huoneistoa",
        arrivalInfoNotSent: "Tietojasi ei ole rekisteröity taloyhtiöön",
    },

    ownInfoEditView: {
        topic: "Omat tiedot",
        description: "Muokkaa haluamiasi tietoja. Tallennuksen jälkeen muokkauspyyntösi välittyy taloyhtiön isännöitsijälle. Isännöitsijä päivittää muutokset mahdollisimman pian.",
        additionalInfo: "Viesti isännöitsijälle",
        save: "Tallenna tiedot",
        noticeSentSuccessfully: "Tiedot tallennettu onnistuneesti. Isännöitsijä tarkistaa muutokset ja saat viestin päivityksestä.",
    },

    defectNoticeView: {
        topic: "Vikailmoitus",
        subtopic: "Täytä alla oleva vikailmoitus. Vikailmoitus lähtee tämän jälkeen isännöitsijätoimiston asiakaspalveluun, joka välittää huoltopyynnön seuraavana arkipäivänä huoltoliikkeelle. Kiireellisissä ja hätätapauksissa olethan suoraan yhteydessä huoltopäivystykseen tai yleiseen hätänumeroon.",
        apartment: "Huoneisto",
        name: "Nimi",
        address: "Osoite",
        wishedTime: "Toivottu käyntiajankohta",
        entranceType: "Huoltomiehen sisäänpääsy",
        description: "Vian kuvaus",
        pets: "Huomioitavat kotieläimet",
        noticeSentSuccessfully: "Vikailmoituksesi on lähetetty onnistuneesti. Toimitamme huoltopyynnön huoltoliikkeelle mahdollisimman nopeasti.",
        noApartment: "Ei huoneistoa",
    },

    leavingNoticeView: {
        topic: "Lähtöilmoitus",
        subtopic: "Täytä lomakkeen tiedot ja allekirjoita sopimus. Isännöitsijä käsittelee lähtöilmoituksen mahdollisimman nopeasti.",
        apartmentInfo: "Asunnon tiedot",
        apartment: "Huoneisto",
        form: "Muuttolomake",
        moveOutDate: "Muuttopäivä",
        comment: "Lisätiedot (esim. huoneistoon asumaan jäävän/jäävien henkilöiden nimet)",
        signature: "Allekirjoitus (tunnistautumistapa)",
        noticeSentSuccessfully: "Lähtöilmoitus jätetty onnistuneesti.",
    },

    materialView: {
        topic: "Materiaalit",
        allMaterials: "Kaikki materiaalit",
    },

    rolePopup: {
        topic: "Sovelluksen roolit",
        subtopic: "Sovelluksen avulla näet, kenelle materiaalit ovat nähtävissä.",
        resident: "Asukkaat",
        stakeholder: "Osakkaat",
        boardMember: "Hallituksen jäsenet",
    },

    requestsView: {
        topic: "Viestit",
        subtopic: "Alla näet viestisi",
    },

    requestView: {
        topic: "Viestit",
    },

    signatureTypes: {
        1: "Taloyhtiösovellus",
    },

    entranceTypes: {
        1: "Pääsy yleisavaimella",
        2: "Käynnistä sovittava ilmoittajan kanssa",
    },

    errorCodes: {
        Unrecognized: "Tuntematon virhe",

        MissingPinOrEmail: "Puuttuva pin tai sähköposti",
        MissingOwnInfo: "Puutteelliset tiedot",
        MissingMessageType: "Viestin tyyppi puuttuu",

        UnauthorizedUser: "Käyttäjää ei löytynyt",
        UnauthorizedPin: "Virheellinen tai vanhentunut pin-koodi",

        GetParkingSlotsFail: "Parkkipaikkojen haku epäonnistui",
        GetSaunasFailed: "Saunojen haku epäonnistui",
        GetSaunasShiftsFailed: "Saunavuorojen haku epäonnistui",
        GetHousingCompaniesFailed: "Taloyhtiöiden haku epäonnistui",
        GetHousingCompanyFailed: "Taloyhtiön haku epäonnistui",
        GetApartmentFailed: "Huoneiston haku epäonnistui",
        GetAttachmentFailed: "Tiedoston haku epäonnistui",
        GetMessageFailed: "Tiedotteen haku epäonnistui",
        GetAccountFailed: "Käyttäjätilin haku epäonnistui",
        GetAppUserFailed: "Käyttäjän haku epäonnistui",
        GetOwnInfoFailed: "Omien tietojen haku epäonnistui",
        GetApartmentsFailed: "Huoneistojen haku epäonnistui",
        GetInstallationFailed: "Isännöitsijän haku epäonnistui",

        RemoveHousingCompanyFailed: "Taloyhtiön poistaminen epäonnistui",
        RemoveParkingFailed: "Parkkipaikan purkusopimuksen lähetys epäonnistui",
        RemoveSaunaFailed: "Saunavuoron purkusopimuksen lähetys epäonnistui",
        
        CreateArrivalNoticeFailed: "Tuloilmoituksen luominen epäonnistui",
        CreateDefectNoticeFailed: "Vikailmoituksen luominen epäonnistui",
        CreateLeavingNoticeFailed: "Lähtöilmoituksen luominen epäonnistui",
        CreateRequestOwnInfoFailed: "Omien tietojen muutosilmoituksen luominen epäonnistui",
        CreatePinFailed: "Pin-koodin luominen epäonnistui",
        CreateAppUserFailedUserExists: "Käyttäjän luominen epäonnistui: Käyttäjä on jo olemassa",
        CreateAppUserFailed: "Käyttäjän luominen epäonnistui",
        
        ReserveParkingFailed: "Parkkipaikan varaus epäonnistui",
        ReserveSaunaFailed: "Saunavuoron varaus epäonnistui",
        
        UpdateOwnInfoNoChanges: "Mitään tietoja ei muutettu",
        UpdataOwnInfoFailed: "Omien tietojen muuttaminen epäonnistui",
        UpdateOwnInfoEmailAlreadyInUse: "Sähköpostin muuttaminen epäonnistui: Sähköposti on jo käytössä",
        
        SetHousingCompanyFailed: "Taloyhtiön asettaminen epäonnistui",
    }
};
